<deletemodal id="customer-tabs" [deleteModal]="deleteModal"></deletemodal>
<div class="main center-75per-width">    
    <div class="tab-content">
        <div role="tabpanel" class="tab-pane fade in active  department-user-search padd-top-0" id="users">
            
                <div class=" " >                            
                        <form [formGroup]="departmentForm" novalidate (ngSubmit)="onSubmit(departmentForm.value, departmentForm.valid)" class=" col-xs-12 no-padding ticket-color-validation">

                            <div class="row">
                                <div class="col-xs-12 color-blue mb-10">{{'department-system.DEPARTMENT INFORMATION' |translate |translateKey}}</div>
                                <div class="col-xs-11 left-padding-0">                                        
                                    <!-- Operating Country -->
                                    <div class="col-md-3 floating-input">
                                        <select id="autofocus-element" class="form-control" formControlName="operatingCountryId" tabindex="1" (change)="getTicketTypesAndSubTypes()">        
                                            <option *ngIf = "isCountriesLoading" value="">{{'department-system.Loading...' |translate |translateKey}}</option>                                                                                                                                                           
                                            <option value="">{{'department-system.Operating Country' |translate |translateKey}}</option>
                                            <option *ngFor="let country of countries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
                                        </select>
                                        <div class="alert-msg" *ngIf="!departmentForm.controls['operatingCountryId'].valid  && departmentForm.controls['operatingCountryId'].hasError('required') && (departmentForm.controls['operatingCountryId'].touched || isSubmitted)">
                                        {{'validation-message.Operating Country is required' |translate |translateKey}}
                                        </div>
                                    </div>
                                    <!-- Department Name -->
                                    <div class="col-md-3 floating-input floatLabelContainer">
                                        <input id="autofocus-name-element" type="text" float-label class="form-control" required formControlName="name" maxlength="100" tabindex="1" placeholder="{{'department-system.Department Name' |translate}}"/>
                                
                                        <div class="alert-msg" *ngIf="!departmentForm.controls['name'].valid && departmentForm.controls['name'].hasError('required') &&(departmentForm.controls['name'].touched|| isSubmitted)">
                                            <div *ngIf="departmentForm.controls['name'].errors.required">
                                                {{'validation-message.Department Name is required'|translate |translateKey}}
                                            </div>
                                            <div *ngIf="departmentForm.controls['name'].errors.noEmptyString">
                                                {{'validation-message.Should not contain a whitespace'|translate |translateKey}}.
                                            </div>
                                            <div *ngIf="!departmentForm.controls['name'].errors.noEmptyString && departmentForm.controls['name'].errors.alphaNumericValidation">
                                                {{'validation-message.Only alpha numeric characters are allowed'|translate |translateKey}}.
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Email -->
                                    <div class="col-md-4 floating-input floatLabelContainer">
                                        <input type="text" float-label class="form-control" formControlName="email" placeholder="{{'department-system.Email' |translate |translateKey}}" tabindex="1" >
                                        
                                        <div class="alert-msg" *ngIf="!departmentForm.controls['email'].valid && departmentForm.controls['email'].touched">
                                            <div *ngIf="departmentForm.controls['email'].errors.noEmptyString">
                                                {{'validation-message.Should not contain a whitespace'|translate |translateKey}}.
                                            </div>
                                        </div>
        
                                        <div class="alert-msg" *ngIf="!departmentForm.controls['email'].valid && (departmentForm.controls['email'].touched|| isSubmitted)">
                                            <div class="alert-msg" *ngIf="departmentForm.controls['email'].errors.pattern">
                                                    {{'validation-message.Please Enter a Valid Email ID' |translate |translateKey}}
                                            </div>
                                        </div>
                                        <div class="alert-msg" *ngIf="!departmentForm.controls['email'].valid && (departmentForm.controls['email'].touched|| isSubmitted)">
                                        <div *ngIf="departmentForm.controls['email'].errors.required">
                                                {{'validation-message.Email is required'|translate |translateKey}}
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 top-6">
                                        <input type="checkbox"  id="status" checked formControlName ="status" tabindex="1"/>                                        
                                        <label>{{'config-system.Active' |translate |translateKey}}</label>
                                    </div>
                                    

                                </div>
                                <div class="col-xs-1"></div>
                            </div>
                            <!-- Button blocks -->
                            <div class="text-right">
                                <button id="search-button"  class="btn blue-button"  *ngIf="!departmentId" tabindex="4" type="submit">
                                    {{'department-system.ADD' |translate |translateKey}}
                                </button>
                                <button id="update-button" class="btn blue-button" *ngIf="departmentId" tabindex="4" type="submit">
                                    {{'department-system.Update' |translate |translateKey}}
                                </button>
                                    
                                <button type="button" class="btn grey-button" tabindex="0" (keyup.enter)="alertOnClearingOfData()" (click)="alertOnClearingOfData()" tabindex="4">
                                    {{'department-system.CANCEL' |translate |translateKey}}
                                </button>
                            </div>                                 
                        </form>                                           
                </div> 
        </div>
    </div>        
</div> 

<modal #emailUpdateConfirmation>
    <modal-header>
        <div class="color-blue">{{'department-system.Confirmation Message' |translate |translateKey}}
            <span class="fa-close-icon" (click)="closeModal()">
                <i class="fa fa-close"></i>
            </span>
        </div>
    </modal-header>
    <modal-content>
        <div class ="text-size">
        <p>{{'department-system.We have an existing email configuration setup for this department with emailID.' |translate  |translateKey}}&nbsp;[{{department?.email}}]</p>
        <p>{{'department-system.Updating this will impact the previous email setup.' |translate  |translateKey}}</p>
        <p>{{'department-system.Please contact Support team for any changes to existing configuration' |translate  |translateKey}}</p>
        <p>{{'department-system.Do you want to continue ?' |translate  |translateKey}}</p>
    </div>
    </modal-content>
    <modal-footer>
        <button class="btn btn-primary"
            (click)="updateDepartmentConfirmation()">{{'department-system.Yes' |translate  |translateKey}}</button>
        <button class="btn btn-danger cancel"
            (click)="closeModal()">{{'department-system.No' |translate  |translateKey}}</button>
    </modal-footer>
</modal>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/department/department.component.html